import { motion } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import { BUSINESS, waLink } from "../data/site";
import { useQuote } from "./QuoteModal";

export default function FloatingActions({ waTopic }) {
  const { openQuote } = useQuote();
  return (
    <>
      {/* Desktop floating buttons */}
      <div className="hidden sm:flex fixed right-5 bottom-5 z-[70] flex-col gap-3">
        <motion.a
          href={waLink(waTopic)} target="_blank" rel="noreferrer"
          data-testid="float-whatsapp" aria-label="WhatsApp us"
          whileHover={{ scale: 1.08 }} whileTap={{ scale: 0.95 }}
          className="w-13 h-13 p-3.5 rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_rgba(0,0,0,.4)] flex items-center justify-center"
        >
          <MessageCircle size={22} strokeWidth={2} />
        </motion.a>
        <motion.a
          href={BUSINESS.phoneHref}
          data-testid="float-call" aria-label="Call us"
          whileHover={{ scale: 1.08 }} whileTap={{ scale: 0.95 }}
          className="w-13 h-13 p-3.5 rounded-full btn-gold shadow-[0_8px_24px_rgba(0,0,0,.4)] flex items-center justify-center"
        >
          <Phone size={22} strokeWidth={2} />
        </motion.a>
      </div>

      {/* Mobile sticky contact bar */}
      <div className="sm:hidden fixed bottom-0 left-0 w-full z-[70] p-3 glass-nav border-t border-white/10 flex gap-2.5">
        <a href={BUSINESS.phoneHref} data-testid="sticky-call-mobile" aria-label={`Call ${BUSINESS.phone}`}
          className="shrink-0 w-12 rounded-sm border border-[#D4AF37]/60 text-[#D4AF37] flex items-center justify-center">
          <Phone size={19} strokeWidth={1.8} />
        </a>
        <a href={waLink(waTopic)} target="_blank" rel="noreferrer" data-testid="sticky-whatsapp-mobile" aria-label="WhatsApp us"
          className="shrink-0 w-12 rounded-sm bg-[#25D366] text-white flex items-center justify-center">
          <MessageCircle size={19} strokeWidth={1.8} />
        </a>
        <button data-testid="sticky-quote-mobile" onClick={openQuote} className="btn-gold flex-1 rounded-sm py-3.5 text-sm">
          Get Free Quote
        </button>
      </div>
    </>
  );
}
